var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#005CB9",
    stroke: "#005CB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17.2366C20.9162 17.2366 22.875 15.2778 22.875 12.8616C22.875 10.4453 20.9162 8.48657 18.5 8.48657C16.0838 8.48657 14.125 10.4453 14.125 12.8616C14.125 15.2778 16.0838 17.2366 18.5 17.2366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42022 29.0347C8.36322 29.0331 8.30714 29.0216 8.25517 29.001C8.20321 28.9803 8.15638 28.9508 8.11738 28.9143C8.07837 28.8777 8.04795 28.8347 8.02785 28.7878C8.00775 28.7409 7.99836 28.6909 8.00023 28.6408C8.00023 26.1926 9.10646 23.8446 11.0755 22.1134C13.0446 20.3822 15.7153 19.4097 18.5 19.4097C21.2847 19.4097 23.9554 20.3822 25.9245 22.1134C27.8935 23.8446 28.9998 26.1926 28.9998 28.6408C29.0016 28.6909 28.9923 28.7409 28.9722 28.7878C28.952 28.8347 28.9216 28.8777 28.8826 28.9143C28.8436 28.9508 28.7968 28.9803 28.7448 29.001C28.6929 29.0216 28.6368 29.0331 28.5798 29.0347H8.42022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogo);
export default __webpack_public_path__ + "static/media/ProfileLogo.4d58859219b278a8613c489bb3aa4382.svg";
export { ForwardRef as ReactComponent };